export default "__VITE_ASSET__ByhnP$Gg__"